<script setup>
    import { reactive, ref, computed } from 'vue'
    import FaceImageSlots from './FaceImageSlots.vue'
    import { createEmptyImages } from '../utils/faceImages.js'

    const emit = defineEmits(['goConfirm', 'close'])

    const props = defineProps({
        formData: Object
    })
    
    // 登録ユーザー情報
    const reactiveObj = reactive({
        userId: props.formData?.userId ?? '',
        userName: props.formData?.userName ?? '',
        images: props.formData?.images ?? createEmptyImages()
    })

    const userInfos = ref(
        props.formData?.userInfos ?? [
            { name: '', content:'', placeholder1: 'メールアドレス', placeholder2: 'example@example.com'}
    ])

    // 実行ボタンの活性/非活性化
    const isValid = computed(() => {
        // 画像1は必須
        return reactiveObj.userId && reactiveObj.userName && reactiveObj.images[0].file
    })
    // 項目欄 追加
    const addUserInfo = () => {
        let form_body = {
            name: '', content:'', placeholder1: '入力してください', placeholder2: '入力してください'
        }
        userInfos.value.push(form_body);
    }
    // 項目欄 削除
    const deleteUserInfo = (index) => {
        userInfos.value.splice(index, 1);
    }

    // ユーザー情報登録確認画面へ
    const goConfirm = () => {
        emit('goConfirm', {
            userId: reactiveObj.userId,
            userName: reactiveObj.userName,
            images: reactiveObj.images,
            userInfos: userInfos.value
        })

    }
    // ユーザー登録画面クローズ
    const closeRegist = () => {
        emit('close')
    }

</script>
<template>
    <div class="mainView">
        <nav class="breadcrumb">
            <span class="breadcrumb-sub" @click="closeRegist">利用者管理 </span>
            <span> &gt; </span>
            <span class="breadcrumb-main"> 利用者新規登録</span>
        </nav>
        <div class="titleArea">
            <p class="title">利用者新規登録</p>
            <div class="titleTextArea">
                <p class="titleText">新しい利用者を登録します。ユーザー情報と顔画像を登録してください。</p>
            </div>
        </div>
        <div class="userRegistArea">
            <div class="inputUserInfoArea">
                <p class="registUserTitle" ><span class="fontColorPk">① </span>基本情報</p>
                <div class="formRow">
                    <p class="label">ユーザーID <span class="requireView">必須</span></p>
                    <div class="inputArea">
                        <input type="text" placeholder="例) user-0001" v-model="reactiveObj.userId">
                        <p class="note">半角英数字、ハイフン（-）、アンダースコア（_）が使用できます。</p>
                    </div>
                </div>
                <div class="formRow">
                    <p class="label">ユーザー名 <span class="requireView">必須</span></p>
                    <div class="inputArea">
                        <input type="text" placeholder="例) 山田 太郎" v-model="reactiveObj.userName">
                        <p class="note">ユーザーの氏名または表示名を入力してください。</p>
                    </div>
                </div>
                <table class="userInfoTable">
                    <thead>
                        <tr>
                            <th>項目</th>
                            <th>内容</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(userInfo, index) in userInfos" :key="index">
                            <td>
                                <input class="inputUsrInfo" v-model="userInfo.name" :placeholder="userInfo.placeholder1">
                            </td>
                            <td>
                                <input class="inputUsrInfo" v-model="userInfo.content" :placeholder="userInfo.placeholder2">
                            </td>
                            <td>
                                <button class="deleteButton" @click="deleteUserInfo(index)"><img src="../assets/usermng_delete.png" class="deleteIcon"></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div id="addUserArea">
                    <button class="exeButton textLeft" @click="addUserInfo()">＋ 項目を追加</button>
                </div>
                <p class="textLeft note">※ 上記は任意項目です。必要に応じて項目を追加してください。</p>
            </div>
            <div class="inputUserImgArea">
                <p class="registUserTitle" ><span class="fontColorPk">② </span>顔画像登録 <span class="maxImageBadge">最大3枚</span></p>
                <p class="textLeft imgDescription">顔画像を1〜3枚登録できます。複数の顔画像を登録することで、認証精度の向上が期待できます。</p>
                <FaceImageSlots v-model="reactiveObj.images" />
            </div>
            
        </div>
        <div class="userRegistButtonArea">
            <button type="button" class="clearButton" @click="closeRegist">キャンセル</button>
            <button type="button" class="nextButton" @click="goConfirm" :disabled="!isValid">確認画面へ</button>
        </div>
    </div>
</template>

<style scoped>
    .breadcrumb{
        align-items: left;
        text-align: left;
        padding-top:15px;
        padding-left:20px;
    }
    .breadcrumb-sub{
        font-size: 18px;
        margin: 0 10px;
        cursor:pointer;
    }
    .breadcrumb-main{
        font-size: 18px;
        margin: 0 10px;
        font-weight: bold;
    }
    .userRegistArea {
        width:95%;
        margin:0 auto;
        border-radius: 10px;
        border: 1px solid #e0e0e0;
        padding:20px;
    }
    .inputUserInfoArea{
        width:100%;
        border-bottom: 1px solid #cecbcb;
        padding:15px;
        box-sizing:border-box;
    }
    .registUserTitle {
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        padding:10px;
    }
    .formRow {
        display: flex;
        align-items: flex-start;
        gap: 20px;
        margin-bottom: 20px;
    }
    .inputArea {
        display: flex;
        flex-direction: column;
        margin-top: 10px;
    }
    .inputArea input {
        width: 90%;
        padding: 8px;
        border-radius: 10px;
        margin:0 10px;
        height:40px;
    }
    .note {
        font-size: 15px;
        color: #777;
        margin-top: 5px;
    }
    .label {
        width: 150px;
        text-align: right;
        margin-top: 8px;
        font-weight: bold;
        padding:10px;
        display: flex;
        white-space: nowrap;
    }
    
    .userInfoTable {
        width: 100%;
        border-collapse: separate;
    }
    .userInfoTable thead th {
        background: #eae6e7;
        padding: 12px;
        text-align: left;
        font-weight: bold;
    }
    .userInfoTable tbody tr {
        background: #fff;
        border-radius: 8px;
        margin-bottom: 10px;
    }
    .userInfoTable td:last-child {
        display: flex;
        text-align: center;
        vertical-align: middle; 
    }
    .userInfoTable tbody td {
        padding: 10px 15px;
        vertical-align: middle;
    }

    .userInfoTable thead tr th:first-child {
        border-top-left-radius: 8px;
    }
    .userInfoTable thead tr th:last-child {
        border-top-right-radius: 8px;
    }
    #addUserArea{
        border-radius: 10px;
        border: 1px solid #e0e0e0;
        background-color: white;
        padding:10px;
        text-align: left;
        margin: 10px 0 10px 0;
    }

    .inputUserImgArea {
        display: block;
        gap: 40px;
        justify-content: left;
        margin-top: 20px;
    }

    .userRegistButtonArea {
        display: flex;
        justify-content: center;
        margin:20px;
        gap:20px;
    }
    
    .inputUsrInfo {
        width: 90%;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 6px;
        text-align: left;
    }
    .deleteButton {
        width: 45px;
        height: 45px;
        border: 1px solid #ccc;
        background: #fff;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .deleteIcon{
        width:30px;
        height: 30px;
        
    }

    @media (max-width: 1024px) {
        .userRegistArea {
            width: 100%;
            margin: 0 auto;
            padding: 16px;
        }
        .formRow {
            flex-wrap: wrap;
            gap: 12px;
        }
        .label {
            width: 100%;
            text-align: left;
            margin-top: 0;
            padding: 0 10px 0 0;
        }
        .inputArea input {
            width: 100%;
            margin: 0;
        }
        .userRegistButtonArea {
            flex-direction: column;
        }
        .exeButton,
        .clearButton {
            width: 100%;
        }
    }

    @media (max-width: 768px) {
        *, *::before, *::after {
            box-sizing: border-box;
        }
        .breadcrumb{
            margin-top: 15px;
            padding:10px;
            font-size:14px;
        }
        .breadcrumb-sub, .breadcrumb-main{
            font-size:16px;
            margin:0 3px;
        }
        .userRegistArea {
            padding:10px;
            margin:0;
        }
        .inputArea, .inputUserInfoArea, .inputUserImgArea, .formRow{
            min-width:0;
        }
        .formRow {
            flex-direction:column;
            gap:5px;
        }
        .inputArea input {
            width:100%;
            margin:0;
            box-sizing:border-box;
        }
        .label{
            width:100%;
            text-align:left;
            display:flex;
            align-items:center;
            gap:8px;
            margin-bottom:8px;
            font-size:16px;
        }
        .note{
            font-size:13px;
            line-height:1.6;
        }
        .inputArea input{
            width:100%;
            margin:0;
            box-sizing:border-box;
        }
        .userInfoTable, .userInfoTable tbody, .userInfoTable tr,.userInfoTable td{
            display:block;
            width:100%;
        }
        .userInfoTable thead{
            display:none;
        }
        .userRegistButtonArea{
            flex-direction:column;
        }
        .userRegistButtonArea button{
            width:100%;
            height:48px;
            font-size:16px;
        }
    }
</style>